// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
	font-family: 'Lato';
	/* width: fit-content; */
	/* margin-left: auto; */
	/* margin-right: auto; */
}

.ck-content {
	font-family: 'Lato';
	line-height: 1.6;
	word-break: break-word;
	height: 500px;
}

.editor-container_classic-editor .editor-container__editor {
	/* min-width: 795px; */
	/* max-width: 795px; */
}

.ck-content h3.category {
	font-family: 'Oswald';
	font-size: 20px;
	font-weight: bold;
	color: #555;
	letter-spacing: 10px;
	margin: 0;
	padding: 0;
}

.ck-content h2.document-title {
	font-family: 'Oswald';
	font-size: 50px;
	font-weight: bold;
	margin: 0;
	padding: 0;
	border: 0;
}

.ck-content h3.document-subtitle {
	font-family: 'Oswald';
	font-size: 20px;
	color: #555;
	margin: 0 0 1em;
	font-weight: bold;
	padding: 0;
}

.ck-content p.info-box {
	--background-size: 30px;
	--background-color: #e91e63;
	padding: 1.2em 2em;
	border: 1px solid var(--background-color);
	background: linear-gradient(
			135deg,
			var(--background-color) 0%,
			var(--background-color) var(--background-size),
			transparent var(--background-size)
		),
		linear-gradient(
			135deg,
			transparent calc(100% - var(--background-size)),
			var(--background-color) calc(100% - var(--background-size)),
			var(--background-color)
		);
	border-radius: 10px;
	margin: 1.5em 2em;
	box-shadow: 5px 5px 0 #ffe6ef;
}

.ck-content blockquote.side-quote {
	font-family: 'Oswald';
	font-style: normal;
	float: right;
	width: 35%;
	position: relative;
	border: 0;
	overflow: visible;
	z-index: 1;
	margin-left: 1em;
}

.ck-content blockquote.side-quote::before {
	content: '“';
	position: absolute;
	top: -37px;
	left: -10px;
	display: block;
	font-size: 200px;
	color: #e7e7e7;
	z-index: -1;
	line-height: 1;
}

.ck-content blockquote.side-quote p {
	font-size: 2em;
	line-height: 1;
}

.ck-content blockquote.side-quote p:last-child:not(:first-child) {
	font-size: 1.3em;
	text-align: right;
	color: #555;
}

.ck-content span.marker {
	background: yellow;
}

.ck-content span.spoiler {
	background: #000;
	color: #000;
}

.ck-content span.spoiler:hover {
	background: #000;
	color: #fff;
}

.ck-content pre.fancy-code {
	border: 0;
	margin-left: 2em;
	margin-right: 2em;
	border-radius: 10px;
}

.ck-content pre.fancy-code::before {
	content: '';
	display: block;
	height: 13px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	margin-bottom: 8px;
	background-repeat: no-repeat;
}

.ck-content pre.fancy-code-dark {
	background: #272822;
	color: #fff;
	box-shadow: 5px 5px 0 #0000001f;
}

.ck-content pre.fancy-code-bright {
	background: #dddfe0;
	color: #000;
	box-shadow: 5px 5px 0 #b3b3b3;
}

.ck-viewer .ck-content {
  height: auto !important;
	min-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/ckeditor.css"],"names":[],"mappings":"AAGA;CACC,mBAAmB;CACnB,wBAAwB;CACxB,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,oBAAoB;CACpB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,yCAAyC;CACzC;;;;;;;;;;;GAWE;CACF,mBAAmB;CACnB,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,cAAc;AACf;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,YAAY;CACZ,mDAA+W;CAC/W,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,6BAA6B;AAC9B;;AAEA;EACE,uBAAuB;CACxB,iBAAiB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap');\r\n\r\n.main-container {\r\n\tfont-family: 'Lato';\r\n\t/* width: fit-content; */\r\n\t/* margin-left: auto; */\r\n\t/* margin-right: auto; */\r\n}\r\n\r\n.ck-content {\r\n\tfont-family: 'Lato';\r\n\tline-height: 1.6;\r\n\tword-break: break-word;\r\n\theight: 500px;\r\n}\r\n\r\n.editor-container_classic-editor .editor-container__editor {\r\n\t/* min-width: 795px; */\r\n\t/* max-width: 795px; */\r\n}\r\n\r\n.ck-content h3.category {\r\n\tfont-family: 'Oswald';\r\n\tfont-size: 20px;\r\n\tfont-weight: bold;\r\n\tcolor: #555;\r\n\tletter-spacing: 10px;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.ck-content h2.document-title {\r\n\tfont-family: 'Oswald';\r\n\tfont-size: 50px;\r\n\tfont-weight: bold;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n}\r\n\r\n.ck-content h3.document-subtitle {\r\n\tfont-family: 'Oswald';\r\n\tfont-size: 20px;\r\n\tcolor: #555;\r\n\tmargin: 0 0 1em;\r\n\tfont-weight: bold;\r\n\tpadding: 0;\r\n}\r\n\r\n.ck-content p.info-box {\r\n\t--background-size: 30px;\r\n\t--background-color: #e91e63;\r\n\tpadding: 1.2em 2em;\r\n\tborder: 1px solid var(--background-color);\r\n\tbackground: linear-gradient(\r\n\t\t\t135deg,\r\n\t\t\tvar(--background-color) 0%,\r\n\t\t\tvar(--background-color) var(--background-size),\r\n\t\t\ttransparent var(--background-size)\r\n\t\t),\r\n\t\tlinear-gradient(\r\n\t\t\t135deg,\r\n\t\t\ttransparent calc(100% - var(--background-size)),\r\n\t\t\tvar(--background-color) calc(100% - var(--background-size)),\r\n\t\t\tvar(--background-color)\r\n\t\t);\r\n\tborder-radius: 10px;\r\n\tmargin: 1.5em 2em;\r\n\tbox-shadow: 5px 5px 0 #ffe6ef;\r\n}\r\n\r\n.ck-content blockquote.side-quote {\r\n\tfont-family: 'Oswald';\r\n\tfont-style: normal;\r\n\tfloat: right;\r\n\twidth: 35%;\r\n\tposition: relative;\r\n\tborder: 0;\r\n\toverflow: visible;\r\n\tz-index: 1;\r\n\tmargin-left: 1em;\r\n}\r\n\r\n.ck-content blockquote.side-quote::before {\r\n\tcontent: '“';\r\n\tposition: absolute;\r\n\ttop: -37px;\r\n\tleft: -10px;\r\n\tdisplay: block;\r\n\tfont-size: 200px;\r\n\tcolor: #e7e7e7;\r\n\tz-index: -1;\r\n\tline-height: 1;\r\n}\r\n\r\n.ck-content blockquote.side-quote p {\r\n\tfont-size: 2em;\r\n\tline-height: 1;\r\n}\r\n\r\n.ck-content blockquote.side-quote p:last-child:not(:first-child) {\r\n\tfont-size: 1.3em;\r\n\ttext-align: right;\r\n\tcolor: #555;\r\n}\r\n\r\n.ck-content span.marker {\r\n\tbackground: yellow;\r\n}\r\n\r\n.ck-content span.spoiler {\r\n\tbackground: #000;\r\n\tcolor: #000;\r\n}\r\n\r\n.ck-content span.spoiler:hover {\r\n\tbackground: #000;\r\n\tcolor: #fff;\r\n}\r\n\r\n.ck-content pre.fancy-code {\r\n\tborder: 0;\r\n\tmargin-left: 2em;\r\n\tmargin-right: 2em;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.ck-content pre.fancy-code::before {\r\n\tcontent: '';\r\n\tdisplay: block;\r\n\theight: 13px;\r\n\tbackground: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==);\r\n\tmargin-bottom: 8px;\r\n\tbackground-repeat: no-repeat;\r\n}\r\n\r\n.ck-content pre.fancy-code-dark {\r\n\tbackground: #272822;\r\n\tcolor: #fff;\r\n\tbox-shadow: 5px 5px 0 #0000001f;\r\n}\r\n\r\n.ck-content pre.fancy-code-bright {\r\n\tbackground: #dddfe0;\r\n\tcolor: #000;\r\n\tbox-shadow: 5px 5px 0 #b3b3b3;\r\n}\r\n\r\n.ck-viewer .ck-content {\r\n  height: auto !important;\r\n\tmin-height: 300px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
